import TurfForecastWeatherData from "./TurfForecastWeatherData";

export default TurfForecastWeatherData;